import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail } from "lucide-react"; // or use any icon library you prefer

function Footer() {
  return (
    <footer className="bg-[#F7F4EA] text-[#333] px-6 md:px-20 py-16 border-t border-[#e0dcd5]">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        {/* Logo + Tagline */}
        <div className="w-full md:w-1/3 space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/AB_LOGO_BLUE.svg"
              alt="ArkBuild Logo"
              className="h-12 w-auto"
            />
            <span
              className="text-2xl"
              style={{ fontFamily: "Montserrat", color: "#10273C" }}
            >
              <span className="font-semibold">ARK</span>BUILD
            </span>
          </div>
          <p className="text-sm max-w-sm">
            Building distinctive spaces through refined design and
            craftsmanship.
          </p>
          <p className="text-sm max-w-sm pt-6">
            PO Box 7869, BAULKHAM HILLS, NSW 2153
            <br />
            License No. 467460C
            <br />
            ACN: 677 329 001
          </p>
        </div>

        {/* Quick Links */}
        <div className="w-full md:w-1/3 space-y-2">
          <h4 className="font-medium text-lg mb-2">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:underline">
                Home
              </Link>
            </li>
            <li>
              <Link to="/featured-work" className="hover:underline">
                Featured Work
              </Link>
            </li>
            <li>
              <Link to="/our-story" className="hover:underline">
                Our Story
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact + Social */}
        <div className="w-full md:w-1/3 space-y-4">
          <h4 className="font-medium text-lg mb-2">Contact</h4>
          <p className="text-sm">admin@arkbuild.com.au</p>
          <div className="flex justify-center">
            <div className="flex gap-4 mt-4">
              <a href="mailto:admin@arkbuild.com.au" aria-label="Email">
                <Mail size={20} />
              </a>
              <a
                href="https://www.instagram.com/arkbuild_projects/"
                target="_blank"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="mt-12 text-sm text-center text-[#666]">
        © {new Date().getFullYear()} ARKBUILD. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
